import { mangaList } from '@/mocks/manga';

const top = [...mangaList].sort((a, b) => b.rating - a.rating).slice(0, 5);

export default function TopList() {
  return (
    <section id="toplist" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 py-16 md:px-6 md:py-24">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
        <div className="lg:col-span-1">
          <div className="lg:sticky lg:top-24">
            <span className="text-sm font-medium text-primary-600">WEEKLY LIST</span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">本期安利清单</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              编辑部本周精挑细选的5部好漫。评分、热度与漫友反馈综合加权，只推荐真正值得花时间追更的作品。
            </p>
            <div className="mt-6 rounded-lg border border-accent-200 bg-accent-50 p-5">
              <div className="flex items-center gap-2">
                <i className="ri-information-line text-lg text-accent-700" aria-hidden="true"></i>
                <span className="font-medium text-accent-900">编辑手记</span>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-accent-900">
                本期榜单重点照顾"剧荒星人"。无论你是第一次入坑，还是资深老漫迷，都能从中找到合口味的下一部。
              </p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-2">
          <ol className="flex flex-col gap-5">
            {top.map((item, idx) => (
              <li key={item.id} className="flex gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-200">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-500 font-heading text-xl text-background-50">
                  {idx + 1}
                </span>
                <div className="relative h-32 w-24 shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-36 sm:w-28">
                  <img
                    src={item.cover}
                    alt={`${item.title}漫画封面`}
                    title={`${item.title} · ${item.genre}`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="font-heading text-lg text-foreground-950">{item.title}</h3>
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900 whitespace-nowrap">{item.genre}</span>
                  </div>
                  <p className="mt-1 text-sm text-foreground-600">{item.author} 著</p>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.description}</p>
                  <div className="mt-auto flex flex-wrap items-center justify-between gap-2 pt-3">
                    <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-star-fill text-accent-500" aria-hidden="true"></i>
                        {item.rating.toFixed(1)}
                      </span>
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-file-list-3-line" aria-hidden="true"></i>
                        {item.chapters}话
                      </span>
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-user-heart-line" aria-hidden="true"></i>
                        {item.fans}
                      </span>
                    </div>
                    <a
                      href="#submit"
                      className="inline-flex items-center gap-1 rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 whitespace-nowrap hover:bg-primary-600"
                    >
                      想看·求安利
                      <i className="ri-arrow-right-line" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}